import React, { useEffect } from 'react'

import { usePaymentOptions } from 'mmfintech-checkout-commons'
import { isSingleItemArray, isValidArray, tr } from 'mmfintech-commons'

import { Spinner } from 'mmfintech-portal-commons'
import { PaymentMethods } from '../CorePaymentMethods'
import { PaymentMethodsEmpty, PaymentMethodsWrapper } from './SelectMethod.styled'

interface SelectMethodProps {
  countryCode: string
  method: string
  setMethod: (value: string, path?: string) => void
}

export const SelectMethod: React.FC<SelectMethodProps> = props => {
  const { method, setMethod, countryCode } = props

  const { paymentOptions, paymentOptionsFetching } = usePaymentOptions()

  useEffect(() => {
    if (isSingleItemArray(paymentOptions)) {
      setMethod(paymentOptions[0].paymentMethod)
    }
    // eslint-disable-next-line
  }, [paymentOptions])

  if (paymentOptionsFetching) {
    return <Spinner color='#ef4444' />
  }

  if (isValidArray(paymentOptions)) {
    return <PaymentMethods paymentOptions={paymentOptions} method={method} setMethod={setMethod} />
  }

  return (
    countryCode && (
      <PaymentMethodsWrapper>
        <PaymentMethodsEmpty>{tr('CHECKOUT.PAYMENT.NO_METHODS', 'No payment methods available')}</PaymentMethodsEmpty>
      </PaymentMethodsWrapper>
    )
  )
}
